"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SkipListItem = exports.RemoveFocus = exports.MoveFocus = void 0;
var SkipLinkMethods = _interopRequireWildcard(require("./SkipLinks"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@mui/material/styles");
var _uuid = require("uuid");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  RemoveFocus = e => {
    const target = e?.target;
    let result = false;
    if (target) {
      target.removeEventListener("focusout", SkipLinkMethods.RemoveFocus, false);
      target.removeAttribute("tabindex");
      result = true;
    }
    return result;
  },
  MoveFocus = e => {
    const targetElem = e?.target;
    let result = false,
      focusElem;
    if (targetElem) {
      if (typeof e.preventDefault === "function") {
        e.preventDefault();
      }
      focusElem = document.querySelector(targetElem.getAttribute("href"));
      if (focusElem) {
        focusElem.setAttribute("tabindex", "-1");
        focusElem.focus();
        focusElem.addEventListener("focusout", SkipLinkMethods.RemoveFocus, false);
        result = true && typeof e.preventDefault === "function";
      }
    }
    return result;
  },
  SkipListItem = props => {
    const {
        anchor,
        customTheme = {},
        label,
        testId
      } = props,
      [isVisible, setIsVisible] = (0, _react.useState)(true),
      theme = merge((0, _styles.useTheme)(), customTheme);
    (0, _react.useLayoutEffect)(() => {
      setTimeout(() => {
        if (document.querySelectorAll(anchor).length < 1) {
          setIsVisible(false);
        }
      }, 5);
    }, [anchor]);
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, isVisible > 0 && /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      "data-testid": testId,
      sx: {
        display: {
          xs: "none",
          md: "block"
        },
        listStyle: "none",
        margin: "0",
        padding: "0"
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Button, {
      component: "a",
      disableRipple: true,
      href: anchor,
      onClick: SkipLinkMethods.MoveFocus,
      sx: {
        border: theme.skipLinks.border,
        borderRadius: "0",
        clip: "rect(0 0 0 0)",
        display: "inline-block",
        fontFamily: theme.skipLinks.fontFamily,
        fontSize: theme.skipLinks.fontSize,
        height: "0.1rem",
        margin: "-0.1rem",
        minWidth: "unset",
        overflow: "hidden",
        padding: "1rem",
        position: "absolute",
        textDecoration: "none",
        width: "0.1rem",
        "&:focus-visible": {
          background: "inherit",
          clip: "auto",
          height: "auto",
          margin: "0.1rem",
          overflow: "visible",
          position: "static",
          width: "auto"
        }
      }
    }, label)));
  };

/**
	 * Component to control display of accessible skip links
	 *
	 * @visibleName Skip Links
	 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
	*/
exports.SkipListItem = SkipListItem;
exports.MoveFocus = MoveFocus;
exports.RemoveFocus = RemoveFocus;
const SkipLinks = props => {
  const keySeed = (0, _react.useRef)((0, _uuid.v4)()),
    {
      customTheme = {},
      skipLinksArray = [{
        label: "Skip to Account Sign In",
        anchor: "#navigation__sign-in"
      }, {
        label: "Skip to Site Menu",
        anchor: "#navigation"
      }, {
        label: "Skip to Main Content",
        anchor: "#main-content"
      }, {
        label: "Skip to Footer",
        anchor: "#footer"
      }],
      testId
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme);
  return /*#__PURE__*/_react.default.createElement(_material.List, {
    "data-testid": testId,
    id: "skip-links",
    sx: {
      background: theme.skipLinks.backgroundColor,
      display: "inline-block",
      listStyle: "none",
      margin: "0",
      outline: "none",
      padding: "0",
      position: "fixed",
      top: "0",
      zIndex: "999"
    },
    title: "Accessibility Links"
  }, skipLinksArray.map((linkData, i) => /*#__PURE__*/_react.default.createElement(SkipListItem, _extends({
    customTheme: customTheme,
    key: `SkipLink__list-item--${keySeed.current}-${i}`
  }, linkData))));
};

// Define propTypes;
SkipLinks.propTypes = {
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Array of objects describing each skip link (Default Value: Array of Objects) */
  skipLinksArray: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Internal anchor URL for the skip link */
    anchor: _propTypes.default.string.isRequired,
    /** Link Text */
    label: _propTypes.default.string.isRequired
  })),
  /** @ignore */
  testId: _propTypes.default.string
};
SkipListItem.propTypes = {
  anchor: _propTypes.default.string.isRequired,
  customTheme: _propTypes.default.object,
  label: _propTypes.default.string.isRequired
};

// Export component as default;
var _default = exports.default = SkipLinks;